import React, { useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { ListGroup, Alert } from 'react-bootstrap'
import { serGetTabdata, serSetTabdata } from '../../axios';
import { setTabplateStoAll, setTabplateStoHx } from '../../store/modules/tabplate';
import { setSec } from '../../store/modules/timerslice';
import langList from '../../utils/languagelist.json'
import { rcHxNum, tikoBox, tikoCol, tikoRow, timuKoArray } from '../../utils/publicfunction';

export default function Saveitem() {
  const [msgError, setMsgError] = useState('');
  const [show, setShow] = useState('');

  let {jy,un,...tabdata}=useSelector((state)=>state.tabplate);
  const {sec}=useSelector((state)=>state.timerslice);
  tabdata={...tabdata,sec}
  const {usern}=useSelector((state)=>state.logininfo);
  const {lg}=useSelector((state)=>state.language);
  const dispatch=useDispatch();

  const handleSaveClick = () => {
    serSetTabdata({name:usern,tabdata})
    .then(res =>{
      const code=res.code;
      if(code===24){
        setMsgError(`1${langList.saveitem1[lg]}`);
        setShow('1');
        return;
      }else{
        setMsgError(`0${langList.saveitem2[lg]}`);
        setShow('1');
        return;
      };
    })
    .catch(err =>{
      setMsgError('0'+err.message);
      setShow('1');
    });
  }

  const handleLoadClick = () => {
    serGetTabdata({name:usern})
    .then(res =>{
      const code=res.code;
      if(code===25){
        const {sec,...tabdata}=JSON.parse(res.data);
        dispatch(setTabplateStoAll(tabdata));
        dispatch(setSec(sec));
        setMsgError(`1${langList.saveitem3[lg]}`);
        setShow('2');
        return;
      }else{
        setMsgError(`0${langList.saveitem4[lg]}`);
        setShow('2');
        return;
      };
    })
    .catch(err =>{
      setMsgError('0'+err.message);
      setShow('2');
    });
  }

  const handleHxnumClick = () => {
    const tt=tabdata.tt
    const tiko=timuKoArray(tt)
    const tkRowA=tikoRow(tiko)
    const tkColA=tikoCol(tiko)
    const tkBoxA=tikoBox(tiko)
    
    const nid=[];
    const nold=[];
    const nnew=[];
    tt.forEach((v,i)=>{
      if(v.sh===0){
        const r=i/9|0;
        const c=i%9;
        let str=rcHxNum(tkRowA,tkColA,tkBoxA,r,c)
        str=[1,2,3,4,5,6,7,8,9].map(s => str.includes(s) ? s : '0').join('');
        str=str.replace(/(\d)/g, 'b$1');
        nid.push(i);
        nold.push(v);
        nnew.push(str);
      }
    });
    if(nid.length>0){
      dispatch(setTabplateStoHx({nid,nold,nnew,un}))
    }
  }

  const chip=(
    <div className='pb-5 position-relative'>
      <Alert 
        show={msgError===''?false:true} 
        variant={msgError.substring(0,1)==='0'?'danger':'success'} 
        className='py-1 text-center text-danger position-absolute w-100'
      >
        {msgError.substring(1)}
      </Alert>
    </div>
  )

  if(msgError){
    setTimeout(() => {
      setShow('')
      setMsgError('');
    }, 5000);
  };

  return (
  <ListGroup variant="flush">
    <ListGroup.Item action className='py-3' onClick={handleSaveClick}>{langList.saveitem5[lg]}</ListGroup.Item>
    {show==='1' && chip}
    <ListGroup.Item action className='py-3' onClick={handleLoadClick}>{langList.saveitem6[lg]}</ListGroup.Item>
    {show==='2' && chip}
    <ListGroup.Item action className='py-3' onClick={handleHxnumClick}>{langList.saveitem7[lg]}</ListGroup.Item>
    {show==='3' && chip}
  </ListGroup>
  )
};

